import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function AdmissionsPage() {
  return (
    <Container fluid className="project-section career-utility-page">
      <Container className="career-utility-shell">
        <p className="career-utility-eyebrow">Admissions</p>
        <h1 className="career-utility-title">Admissions Requirements and Enrollment Steps</h1>
        <p className="career-utility-lead">
          Choicest Fruit Career Training Programs are designed for learners seeking practical workforce
          skills through structured, project-based training.
        </p>

        <section className="career-utility-card">
          <h2>Admissions Requirements</h2>
          <ul>
            <li>Minimum age: 14+ (some cohorts may require 16+ based on partner requirements)</li>
            <li>Reliable laptop access and internet connectivity for remote participation</li>
            <li>Commitment to attendance, collaboration, and project milestones</li>
            <li>No prior coding experience required for entry-level pathways</li>
          </ul>
        </section>

        <section className="career-utility-card">
          <h2>Program Prerequisites</h2>
          <ul>
            <li>Basic digital literacy: email, browser navigation, file management</li>
            <li>Willingness to learn version control and project documentation</li>
            <li>Ability to participate in team-based learning and presentations</li>
          </ul>
        </section>

        <section className="career-utility-card admissions-selection-card">
          <h2>Selection Criteria</h2>
          <p className="admissions-selection-intro">Applicants are evaluated based on:</p>
          <ul>
            <li>Motivation to learn and grow.</li>
            <li>Curiosity and problem-solving mindset.</li>
            <li>Commitment to completing the program.</li>
            <li>Ability to collaborate with others.</li>
            <li>Professionalism and communication.</li>
            <li>Alignment with the mission and values of Choicest Fruit.</li>
          </ul>
          <p className="admissions-selection-note">
            Selection is <strong>not based solely on technical ability</strong>. We seek participants who
            demonstrate potential, dedication, and a genuine interest in using technology to make a
            meaningful impact.
          </p>
        </section>

        <section className="career-utility-card">
          <h2>Enrollment Steps</h2>
          <ol>
            <li>Explore programs and select a pathway.</li>
            <li>Submit an enrollment inquiry form.</li>
            <li>Complete advising/interview.</li>
            <li>Review and sign enrollment agreement.</li>
            <li>Finalize payment or funding pathway.</li>
            <li>Begin classes and onboarding.</li>
          </ol>
        </section>

        <div className="career-utility-links">
          <Link to="/courses" className="custom-yellow-btn btn">Back to Career Programs</Link>
          <Link to="/catalog" className="btn btn-primary">Open School Catalog</Link>
          <Link to="/student-resources" className="btn btn-primary">Open Student Resources</Link>
        </div>
      </Container>
    </Container>
  );
}

export default AdmissionsPage;
